export default "__VITE_ASSET__CXiHneEK__"